<template>
    <div id="strategicmap" class="strategic">
        <div v-if="isMobile" class="strategic-header">
            <span style="color:F8F2D8;">{{$t("map")}}</span>
        </div>
        <div class="strategic-row">
            <div class="strategic-img"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StrategicMap",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    components: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.strategic {
    height: 100%;
    padding: 70px 0 0;
    .strategic-row {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        .strategic-img {
            width: 1100px;
            height: auto;
            margin: 50px auto 0;
        }
    }
}
// 多语言
.lang-zh-CN {
    .strategic {
        .strategic-row {
            .strategic-img {
                background: url($cdnPrefix+"/imgs/strategic-map-cn.png")
                    center top no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
.lang-ja {
    .strategic {
        .strategic-row {
            .strategic-img {
                background: url($cdnPrefix+"/imgs/strategic-map-ja.png")
                    center top no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
.lang-en {
    .strategic {
        .strategic-row {
            .strategic-img {
                background: url($cdnPrefix+"/imgs/strategic-map-en.png")
                    center top no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
.lang-th {
    .strategic {
        .strategic-row {
            .strategic-img {
                background: url($cdnPrefix+"/imgs/strategic-map-th.png")
                    center top no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
// 适配小屏
@media screen and (max-width: 1366px) {
    .strategic {
        .strategic-row {
            .strategic-img {
                width: 980px;
                margin: 0 auto;
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .strategic {
        max-height: 500px;
        min-height: 250px;
        padding: 50px 0;
        .strategic-row {
            .strategic-img {
                width: 550px;
                height: 400px;
                margin-top: 20px;
            }
        }
    }
}
@media screen and (max-width: 414px) {
    .strategic {
        padding: 0;
        max-height: 300px;
        .strategic-header {
            width: 100%;
            line-height: 40px;
            font-size: 14px;
            font-weight: bold;
            color: #f8f2d8;
            background: url($cdnPrefix+"/imgs/bgphone-title.png")
                center center no-repeat;
            background-size: 330px 35px;
            text-align: center;
        }
        .strategic-row {
            .strategic-img {
                width: 90%;
                height: 250px;
                margin: 0;
            }
        }
    }
}
@media screen and (max-width: 375px) {
    .strategic {
        .strategic-row {
            .strategic-img {
                height: 230px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/StrategicMap.vue